<template>
  <div>
    <div
      style="display: none"
    />
    <DialogDefault
      :open.sync="myValue"
      title="Erro no envio"
      width="370px"
      @close="close"
    >
      <template v-slot:title>
        <div/>
      </template>
      <div
        v-if="protocoloData.step"
      >
        <div
          class="sucesso-solicitacao-header"
        >
          <svg-icone
            icone="img_helper_receipt"
          />
        </div>
        <div
          class="sucesso-solicitacao-titulo"
        >
          {{ protocoloData.step.titulo }}
        </div>
        <div
          class="sucesso-solicitacao-texto"
        >
          {{ protocoloData.step.descricao }}
        </div>
        <template v-if="protocoloData.step.mostraProtocolo">
          <div class="sucosse-solicitacao-protocolo-box">
            <div class="sucosse-solicitacao-protocolo-box-label">
              PROTOCOLO
            </div>
            <div class="sucosse-solicitacao-protocolo-box-valor-container">
              <div class="sucosse-solicitacao-protocolo-box-valor-protocolo">
                {{ protocoloData.solicitacao.protocolo }}
              </div>
              <el-popover
                placement="bottom"
                trigger="click"
                width="60"
              >
                <div style="text-align: center">
                  Copiado!
                </div>
                <div
                  slot="reference"
                  class="sucosse-solicitacao-protocolo-box-valor-copia-icone"
                  @click="copiar"
                >
                  <SvgIcone
                    :height="14"
                    icone="icon_btn_copy"
                    :width="14"
                  />
                </div>
              </el-popover>
            </div>
          </div>
        </template>

        <ButtonDefault
          title="CONCLUÍDO"
          @click="close"
        />
      </div>
    </DialogDefault>
  </div>
</template>
<script>
import ButtonDefault from '@/components/buttons/ButtonDefault'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogoConclusaoSolicitacao',
  components: { ButtonDefault, DialogDefault },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    protocoloSucesso: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      myValue: false,
      protocoloData: {}
    }
  },
  watch: {
    value (newValue) {
      this.myValue = newValue
    },
    myValue (newValue) {
      if (!newValue) {
        this.$emit('input', false)
      }
    },
    protocoloSucesso (newValue) {
      this.protocoloData = newValue
    }
  },
  computed: {
    ...mapState('TempleteSolicitacaoStore', ['result'])
  },
  methods: {
    ...mapActions('TempleteSolicitacaoStore', ['clean']),
    init () {
      if (this.result) {
        if (this.$route.query.novo) {
          this.protocoloData = { ...this.result }
          this.myValue = true
        }

        this.clean()
      } else {
        this.protocoloData = { ...this.protocoloSucesso }
      }
    },
    copiar () {
      this.$clipboard(this.protocoloData.solicitacao.protocolo)
    },
    close () {
      this.myValue = false
      this.$emit('click')
    }
  },
  mounted () {
    this.init()
  }
}
</script>
